import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import {
  formatApiError,
  type ApiErrorContext,
} from "@/lib/http/error-handler";
import { isBillingAccessDenied } from "@/lib/http/billing-errors";
import { PLAN_LINK_VIEW } from "@/features/billing/planCopy";

interface ApiErrorNoticeProps {
  error: unknown;
  context?: ApiErrorContext;
  className?: string;
}

export function ApiErrorNotice({
  error,
  context = "generic",
  className = "mt-3 text-xs text-red-700",
}: ApiErrorNoticeProps) {
  if (!error) return null;

  const message = formatApiError(error, context);
  const showPlansLink = isBillingAccessDenied(error);

  return (
    <p className={className}>
      {message}
      {showPlansLink ? (
        <>
          {" "}
          <Link to={ROUTES.billing} className="font-semibold text-[var(--accent)]">
            {PLAN_LINK_VIEW}
          </Link>
        </>
      ) : null}
    </p>
  );
}
